
 


<div class="content-wrapper d-print-none">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Requests</h4>
            <div style="background: #ECECEC;padding:30px;">
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedDepartmentId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onFunctionChange($event)">
                              <option value="">-- Select Function --</option>
                              <option [value]="department.id" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select User">
                    
                             <!-- Department  -->
                             <select class="form-control" required [(ngModel)]="selectedUserEmail" name="selectedUserEmail"
                             id="selectedUserEmail"   (change)="onUserChange($event)">
                             <option value="">-- Select User --</option>
                             <option [value]="user.email" *ngFor="let user of Users">{{user.email}}
                             </option>
                           </select>
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Status">
                          <!-- Statuses  -->
                          <select class="form-control" required [(ngModel)]="selectedStatus" name="selectedStatus"
                          id="selectedStatus"   (change)="onStatusChange($event)">
                          <option value="">-- Select Status --</option>
                          <option [value]="status.value" *ngFor="let status of Statuses">{{status.name}}
                          </option>
                        </select>
                    </nz-card>
                  </div>
                </div>

                <div nz-row [nzGutter]="8">
              
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Created Date">
                      <nz-range-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-range-picker>
                      <br>
                      <br> 
                      
                        <button type="button" class="btn btn-primary btn-sm" (click)="GetByDate()">Submit</button>
                    
                   
                    </nz-card>
                  </div>
             
                
                </div>
              </div>

            <div class="table-responsive pt-3">
               
                    <input type="button" value="Export To Excel" (click)="exportExcel()" class="btn-primary"/>
             
                
                <br>
              <nz-table #contractTable [nzData]="Requests" [nzPageSize]="50">
                <thead>
  
                  <tr>
                    <th>
                      #
                    </th>
                    <th>
                      Reference
                    </th>
  
                    <th>
                      Request Date
                    </th>

                    <th>
                      Start Date
                    </th>

                     <th>
                      End Date
                    </th> 
  
  
                    <th  >
                      Created By
                    </th>
  
                    <th  >
                      Function
                    </th>
  
                    <!-- <th>
                      Contractor
                    </th> -->
  
                    <th>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of contractTable.data; let i = index ;" (click)="open(data)" class="clickable">
  
                    <td>
                      {{i+1}}
                    </td>
                    <td>
                      {{ data.reference }}
                    </td>
  
                    <td>
                      {{ data.dateOfRequest | date: 'dd MMMM yyy' }}
                    </td>
                    <td>
                      {{ data.startDate | date: 'dd MMMM yyy' }}
                    </td>

                      <td>
                      {{ data.endDate | date: 'dd MMMM yyy' }}
                    </td>
                   
                    <td  >
                      {{data.createdBy}}
                    </td>
  
                    <td  >
                      {{data.sectionOrDepartment}}
                    </td>
  
                    <!-- <td>
                      {{data.contractorName}}
                    </td> -->
  
                    <td>
                      <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
  
            </div>

            
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible"[nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="row">
          <div  class="col">
            <h5 class="card-title"> Adhoc Request Details</h5>
          </div>
          <div  class="col">
            <img src="../../../assets/images/holcim_logo_color.svg" alt=""
            srcset="" style="height: 30px;">
          </div>
        </div>
      
       
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ UpdateRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Function</b></label>
              <p>{{ UpdateRequest?.sectionOrDepartment }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Location</b></label>
              <p>{{ UpdateRequest?.plantName }}</p>
            </div>

            <!-- <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ UpdateRequest?.costCenterName }}</p>
            </div> -->
          </div>
        </div>

       
        <div class="card-body" >
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Contract Duration (Month)</b></label>
              <p>{{ UpdateRequest?.contractDuration }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ UpdateRequest?.startDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Number of Staff</b></label>
              <p>{{ UpdateRequest?.numberRequired }}</p>
            </div>
          </div>

          <div class="row">

            <!-- <div class="col">
              <label><b>Medical Notes </b></label>
              <p>{{ UpdateRequest?.medicalNotes  }}</p>
            </div> -->

            <div class="col">
              <label><b> Active Number of Employees</b></label>
              <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
            </div>

            <div class="col">
              <label><b>Vendor Name</b></label>
              <p>{{ UpdateRequest?.vendorName }}</p>
            </div>
          </div>


          <div class="row">

            <!-- <div class="col">
              <label><b>Budget Cost</b></label>
              <p>{{ UpdateRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
            </div> -->

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ UpdateRequest?.createdBy }}</p>
            </div>

            <div class="col">
            <label><b>Vendor Cost</b></label>
            <p>{{ UpdateRequest?.vendorCost | currency:"NGN":"symbol-narrow" }}</p>
          </div>
          </div>

          <!-- <div class="row">
            <div class="col">
              <div class="form-group" >
                <label><b>Notes</b></label>
                
                <p>{{ UpdateRequest?.message}}</p>
              </div>
            </div>

            <div class="col">
              <div class="form-group" >
                <label><b>Closed Date</b></label>
                
                <p>{{ UpdateRequest?.closeDate |  date: 'dd MMMM yyyy' }}</p>
              </div>



            </div>

          </div> -->

          <!-- <div class="row">

            <div class="col">
              <label><b>Request Description</b></label>
              <p>{{ UpdateRequest?.jobDescription }}</p>
            </div>

            <div class="col">
              <label><b>Request Justification</b></label>
              <p>{{ UpdateRequest?.justification }}</p>
            </div>
          </div> -->



          
          <!-- <div class="row">

            <div class="col">
              <label><b>Required Qualification & Experience</b></label>
              <p>{{ UpdateRequest?.qualification }}</p>
            </div>

            <div class="col">
              <label><b>Safety Notes</b></label>
              <p>{{ UpdateRequest?.safetyInductionNotes }}</p>
            </div>
          </div> -->
        </div>

        <hr>

         <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
     
      </div>
      <ng-template #footerTpl>
        <div style="float: right" class="d-print-none">
          <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
            (click)="close()">Close</button>
        </div>
      </ng-template>
    </div>
  </div>
</nz-drawer>
          </div>
        </div>
      </div>
  
  
    </div>
  </div>
  